<template>
  <span class="fts-history-log-display">
    <!-- null, undefined -->
    <span class="fts-text-default fts-font-style-italic" v-if="isEmpty">
      (empty)
    </span>
    <!-- date, datetime -->
    <span v-else-if="dataType === 'date'">
      {{moment(log).format('lll')}}
    </span>
    <!-- location -->
    <span v-else-if="dataType === 'location'">
      <span v-if="log.placeName">
        {{log.placeName}}
      </span>
      <span class="fts-text-default fts-font-style-italic" v-else>
        (undefined)
      </span>
      <span v-if="log.lat && log.lng">
        ({{log.lat}}, {{log.lng}})
      </span>
    </span>
    <!-- image, file, signature -->
    <span v-else-if="dataType === 'file'">
      <a
        :href="getFilePath(log.path)"
        target="_blank"
        class="fts-link-primary"
        v-if="log.path"
      >
        {{log.name}}
      </a>
      <span v-else>
        {{log.name}}
      </span>
    </span>
    <!-- images, files -->
    <template v-else-if="dataType === 'files'">
      <span v-for="(x, xInd) in log" :key="x.id">
        <a
          :href="getFilePath(x.path)"
          target="_blank"
          class="fts-link-primary"
          v-if="x.path"
        >
          {{x.name}}
        </a>
        <span v-else>
          {{x.name}}
        </span>
        <span v-if="xInd + 1 !== log.length">
          ,&nbsp;
        </span>
      </span>
    </template>
    <!-- default -->
    <span v-else>{{log}}</span>
  </span>
</template>

<script>
import moment from "moment";
import commons from '../../commons/commons';

export default {
  props: {
    moduleId: [String, Number],
    informationId: String,
    dataType: String,
    log: {}
  },
  methods: {
    moment,
    getFilePath(path) {
      return commons.getFilePath(path, `${this.moduleId}-${this.informationId}`);
    }
  },
  computed: {
    isEmpty() {
      const isEmptyArray = (val) => val && val.length;
      const isEmptyObject = (val) => {
        for(var i in val) return false;
        return true;
      }
      return (
        this.log === null ||
        this.log === undefined ||
        this.log === '' ||
        (commons.isObject(this.log) && isEmptyArray(this.log)) ||
        (commons.isArray(this.log) && isEmptyObject(this.log))
      );
    }
  }
}
</script>

<style lang="scss" scoped>
.fts-history-log-display {
  overflow-wrap: break-word;
}
</style>